export enum SearchView {
  Default = "default",
  Table = "table"
}